import { ModifierGroup } from '@wix/ambassador-ecom-v1-order/types';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import {
  classes as gridLaoutClasses,
  st,
} from '../../../../../../../../core/gridayout/styles.st.css';
import { BookingDTO } from '../../../../../../../../types';
import { isCourse } from '../../../../../../../../utils/bookInfo';
import { BookingBodyContentRowDataHooks } from '../../../../../datahooks';
import { classes } from './BookingBodyContentRow.st.css';
import BookingBodyContentActionLinks from './RowContents/BookingBodyContentActionLinks';
import BookingBodyContentAddOnsInfo from './RowContents/BookingBodyContentAddOnsInfo';
import BookingBodyContentDuration from './RowContents/BookingBodyContentDuration';
import BookingBodyContentParticipantInfo from './RowContents/BookingBodyContentParticipantInfo';
import BookingBodyContentServiceName from './RowContents/BookingBodyContentServiceName';
import BookingBodyContentStaffInfo from './RowContents/BookingBodyContentStaffInfo';

export interface BookingBodyContentRowProps {
  booking: BookingDTO;
  withServiceName?: boolean;
  addOnGroups?: ModifierGroup[];
}

const BookingBodyContentRow: FC<BookingBodyContentRowProps> = ({
  booking,
  withServiceName,
  addOnGroups,
}) => {
  const { isMobile } = useEnvironment();
  const staffName = booking.staffInfo?.fullName;
  const isCourseBooking = isCourse(booking);

  return (
    <div className={classes.root}>
      <div
        className={st(gridLaoutClasses.container, classes.container)}
        data-hook={BookingBodyContentRowDataHooks.Main}
      >
        <div>
          {withServiceName && (
            <div data-hook={BookingBodyContentRowDataHooks.ServiceName}>
              <BookingBodyContentServiceName booking={booking} />
            </div>
          )}
          {!!addOnGroups?.length && (
            <div
              className={classes.addOns}
              data-hook={BookingBodyContentRowDataHooks.AddOnGroups}
            >
              <BookingBodyContentAddOnsInfo addOnGroups={addOnGroups} />
            </div>
          )}
          {staffName && <BookingBodyContentStaffInfo booking={booking} />}
          {!isCourseBooking && <BookingBodyContentDuration booking={booking} />}
          <BookingBodyContentParticipantInfo booking={booking} />
          <BookingBodyContentActionLinks booking={booking} />
        </div>
        {!isMobile && (
          <div data-hook={BookingBodyContentRowDataHooks.EmptyGridColumn}></div>
        )}
      </div>
    </div>
  );
};

export default BookingBodyContentRow;
